<template>
  <!--  <el-input v-model="input" @change="currentSel" :type="options.type" :width="options.width"
    :placeholder="options.placeholder" :clearable="options.clearable" :maxlength="options.maxlength"
    :prepend="options.prepend" :append="options.append" :disabled="options.disabled"></el-input> -->
  <van-field v-model="input" @input="currentSel" :label="dModel.label" :placeholder="options.placeholder"
    :maxlength="options.maxlength" :rules="dModel.rules">
  </van-field>
</template>

<script>
  import formDesignMixins from './mixins/formDesignMixins'
  export default {
    name: "DesignInput",
    data() {
      return {
        input: "",
      };
    },
    mixins:[formDesignMixins],
    props: {
      value: {},
      options: {
        type: Object,
        default: function() {
          return {
            "type": "text",
            "width": "100%",
            "defaultValue": "",
            "placeholder": "请输入",
            "clearable": false,
            "maxLength": 0,
            "prepend": "",
            "append": "",
            "tooptip": "",
            "hidden": false,
            "disabled": false,
            "dynamicHide": false,
            "dynamicHideValue": ""
          }
        }
      }
    },
    methods: {
      currentSel: function(selVal) {
        this.$emit("input", selVal);
      },
    },
    watch: {
      value(nv) {
        this.input = nv;
      },
    },
    mounted: function() {
      this.input = this.value;
    },
  };
</script>

<style scoped="scoped">

</style>
